import { ExerciseAnswerSubmission } from "./useTallyConversation";

export const END_CONVERSATION_PROMPT = `The user intends to end the conversation.
Call the end_conversation tool to close the session. Include the skills report only
if the conversation was long enough to assess meaningfully; if it was too short,
call it with no arguments.

Give the user a friendly, supportive and context-aware goodbye`;

export type ConversationScenario = {
  title: string;
  instruction: string;
};

export const SCENARIOS_PROMPT = "The user has chosen the following scenario to practice";

export const EXERCISE_GENERATION_TIMED_OUT =
  "The exercise generation has taken too long and has timed out. Tell a user there's been a technical issue and ask whether to try again.";

export const getExerciseAnswerPrompt = (props: ExerciseAnswerSubmission) =>
  `The student has submitted answer ${props.answerId} for exercise ${props.exerciseId} by clicking it in the UI. 
The user has already been made aware that their answer is ${props.isCorrect ? "correct" : "incorrect"}
You only need to offer brief acknowledgment: three words max
This MCQ is ${props.isLastInSequence ? "finished" : "not yet finished"}`;

export const SCENARIOS: ConversationScenario[] = [
  {
    title: "Give feedback to a report",
    instruction: "You're giving feedback to an employee on their recent performance.",
  },
  {
    title: "Handle tough sales call",
    instruction:
      "You're negotiating with a client who is hesitant about the pricing of your product.",
  },
  {
    title: "Negotiate a contract",
    instruction:
      "You're discussing terms and conditions with a potential business partner.",
  },
  {
    title: "Update leadership on project",
    instruction:
      "You're providing a status update to senior management about a key project.",
  },
  {
    title: "Handle a missed deadline",
    instruction:
      "You're explaining to your manager why a project deadline was missed and how you'll address it.",
  },
  {
    title: "Run a project kickoff",
    instruction:
      "You're leading the kickoff meeting for a new project with your team and stakeholders.",
  },
];
